import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GaugeIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { IndustrialBackdrop } from './ui/IndustrialBackdrop';
import { productBrand, productImage, productImageAlt, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} professional volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-slate-950" data-id="element-88" data-mp="ncq29gqxlsov">
      <IndustrialBackdrop opacity="soft" data-id="element-89" data-mp="3d1ikzavvpeny" />
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-90" data-mp="3d2l95b1th306">
        <span className="flex-1 bg-slate-700" data-id="element-91" data-mp="382ffjpbzl6fg" />
        <span className="w-24 bg-amber-400" data-id="element-92" data-mp="381nvnbrr4x50" />
        <span className="flex-1 bg-slate-700" data-id="element-93" data-mp="3j8ixl0k6uiv8" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-94" data-mp="3j9265qny7uwl">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-amber-400/40 bg-slate-900/80 px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-white" data-id="element-95" data-mp="3o6aqnxwkkb10">
          <GaugeIcon className="h-4 w-4 text-amber-400" aria-hidden="true" data-id="element-96" data-mp="3599ki9ra44vh" /> {productBrand}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-97" data-mp="2qkmv1f7xtwqj">
          <img src={productImage} alt={productImageAlt} className="mx-auto w-full [filter:drop-shadow(0_0_30px_rgba(251,191,36,0.35))_drop-shadow(0_0_80px_rgba(245,158,11,0.25))]" data-id="element-98" data-mp="2lkin4dl3iabx" />
        </motion.div>

        <div className="mt-9" data-id="element-99" data-mp="nbl3anaa4kbi">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-100" data-mp="najg5kfzo7df">
            Get your professional edition now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-white" data-id="element-101" data-mp="ddf3qcby3q9t">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-slate-600/60 bg-slate-900/80 px-3 py-2" data-id="element-102" data-mp="1b049mx9rqn0y">
              <Icon className="h-3.5 w-3.5 text-blue-300" aria-hidden="true" data-id="element-103" data-mp="112g7vndqwf9a" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}